import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import Form from '../component/Form';
import pipe from '../lib/pipe';
import withAppContext, { AppContext } from '../utils/context';
import withSWR from '../utils/api';
import withI18n from '../utils/i18n';
import '../style/checkout.scss';

const Checkout = () => {
  const { t } = useTranslation();
  const { merchantData } = useContext(AppContext);
  const { data, error, isValidating } = useSWR(`/api/merchants/${merchantData._id}/cart`);

  console.log(data, error, isValidating);

  return (
    <div className="o-checkout">
      <div className="m-mobileLogo">
        <img className="a-mobileLogo__image" src={merchantData.logo_media_url} />
      </div>
      <div className="m-formContent">
        <div className="m-form">
          <div className="m-logo">
            <img className="a-logo__image" src={merchantData.mobile_logo_media_url} />
          </div>
          <Form />
          <p>{t('Customer Information')}</p>
        </div>
      </div>
      <div className="m-cartContent">
      </div>
    </div>
  );
};

export default pipe(withAppContext, withSWR, withI18n)(Checkout);
